import { ReactCodeMirrorProps } from '@uiw/react-codemirror'
import { Language } from '@basehub/shared-constants'
import dynamic from 'next/dynamic'

const DynamicRawCodeEditor = dynamic(
  () => import('./raw').then((mod) => mod.RawCodeEditor),
  { ssr: false }
)

type CodeEditorProps = {
  value: string
  onChange: ReactCodeMirrorProps['onChange']
  language: Language | null
  extensions?: ReactCodeMirrorProps['extensions']
}

export const CodeEditor = ({
  value,
  language,
  onChange,
  ...rest
}: CodeEditorProps) => {
  return (
    <DynamicRawCodeEditor
      {...rest}
      onChange={onChange}
      language={language}
      value={value}
    />
  )
}

const DynamicDiffCodeEditor = dynamic(
  () => import('./diff').then((mod) => mod.DiffCodeEditorRaw),
  { ssr: false }
)

type DiffCodeEditorProps = {
  oldValue: string
  newValue: string
  language: Language | null
} & Omit<React.ComponentProps<typeof DynamicDiffCodeEditor>, 'value'>

export const DiffCodeEditor = ({
  language,
  newValue,
  oldValue,
  ...rest
}: DiffCodeEditorProps) => {
  return (
    <>
      <DynamicDiffCodeEditor
        {...rest}
        language={language}
        newValue={newValue}
        oldValue={oldValue}
      />
    </>
  )
}
